import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

const AnnouncementsPage = () => {
    const { t } = useTranslation();

    return (
        <Fragment>
            <Header hclass={'header--styleFour'} />
            <main className="main">
                <section className="announcementsPage sitePageSection">
                    <div className="container">
                        <div className="announcementsPage__heading">
                            <h1>{t('announcements.title')}</h1>
                        </div>

                        <div className="announcementsPage__empty" role="status">
                            <span className="announcementsPage__emptyIcon" aria-hidden="true">!</span>
                            <div>
                                <h2>{t('announcements.empty_title')}</h2>
                                <p>{t('announcements.empty_text')}</p>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default AnnouncementsPage;
